




































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































// @ is an alias to /src
import { Component, Emit, Vue } from "vue-property-decorator";
import Formulario from "@/components/Formulario.vue";
import Navbar from "@/components/Navbar.vue";
import ModelSelector from "@/components/modelSelector.vue";
import VesionsCarsCards from "@/components/versionesAutos.vue";

@Component({
  components: {
    Navbar,
    ModelSelector,
    VesionsCarsCards,
  },
})
export default class Ciaz extends Vue {
  @Emit()
  openModalDetalle(
    auto: string,
    titulo: string,
    interes: string,
    version: string
  ) {
    return {
      auto: auto,
      titulo: titulo,
      interes: interes,
      version: version,
    };
  }
  openPurebaManejoTw() {
    document.getElementById("PMtiket")!.click();
  }

  openModelSelector(): void {
    let curtainForm = document.getElementById("curtain-formM");
    let menuForm = document.getElementById("menu-formM");

    if (curtainForm) {
      curtainForm.style.display = "block";
    }
    menuForm?.classList.remove("disable-menu-formM");
    menuForm?.classList.add("open-menu-formM");
  }

  expand: boolean = true;
  toggleExpand() {
    this.expand = !this.expand;
  }

  checkbox: String = "Manual";
  checked: boolean = false;
  toggleCheckbox() {
    let inputCheck: any = document.getElementById("check");
    this.checked = !this.checked;
    inputCheck.checked = this.checked;
    this.checkbox = this.checkbox == "Manual" ? "Automático" : "Manual";
  }
  mounted() {
    let tiket = this.$route.query.variableName;
    this.$router.push({ query: { variableNavName: "CIAZ" } });
    if (tiket == "1") {
      setTimeout(function () {
        document.getElementById("tiket")!.click();
      }, 1000);
    }
    if (tiket == "2") {
      setTimeout(function () {
        document.getElementById("PMtiket")!.click();
      }, 1000);
    }
  }
  scrollState(state: string) {
    const elem = document.getElementById("scrollBlock");
    elem!.style.overflow = state;
  }
}
